import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, getCurrentInstance } from 'vue';

import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { useAccountEmailDomainActions, useAccountEmailDomainGetters } from '@/store-composables';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
import { AccountEmailDomainPayload, AccountEmailDomainResponse } from '@/api/account_email_domains';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsWorkspaceDomains',
  setup(__props) {

const { fetchAccEmailDomains, addAccEmailDomain, verifyDkim } = useAccountEmailDomainActions();
const { useAccountEmailDomainsArr } = useAccountEmailDomainGetters();

const billingFeatureId = ref(FeatureTypes.CustomerCustomEmailDomains);

async function addVerifiedReplyToEmail() {
	await AppDialogManagerService.openVerifyReplyToEmailDialog();
}

const toast = getCurrentInstance()?.proxy?.$toast || console;

// Fetch account email domans from api
onMounted(async () => {
	await fetchAccEmailDomains();
});

const openAddDomainDialog = async (event: Event, isUpgradeRequired: boolean, indicator) => {
	if (isUpgradeRequired && indicator?.setup) {
		indicator.setup().openUpgrade(event, billingFeatureId.value);
	} else {
		const dialogRes = await AppDialogManagerService.openAddEmailDomainDialog();
		if (!dialogRes) {
			return;
		}
		const { domainName, returnPathName, allowedEmails } = dialogRes;
		if (domainName && allowedEmails?.length) {
			await addDomainClicked(domainName, returnPathName, allowedEmails);
			fetchAccEmailDomains();
		} else {
			toast.error('Domain name & allowed email fields are required');
		}
	}
};

// \\ // \\
const accEmailDomains = useAccountEmailDomainsArr || [];
const filteredEmailDomains = useAccountEmailDomainsArr; // TODO, currently we aren't filtering (Show All/Active/Inactive/Invite)
// \\ // \\

const selectedFilter = ref(0);
const domainSearchInput = ref('');

// Manage items currently not used, remove if not needed // TODO
const manageItems = [
	{ title: 'Show All', value: 0 },
	{ title: 'Active', value: 1 },
	{ title: 'Inactive', value: 2 },
	{ title: 'Invite', value: 3 },
];
const manageItemsMap: Record<number, string> = {};
manageItems.forEach((item) => {
	manageItemsMap[item.value] = item.title;
});
const selectedEmailDomains = ref<AccountEmailDomainResponse[]>([]);

async function writeClipboardText(text: string) {
	try {
		await navigator.clipboard.writeText(text);
	} catch (error: unknown) {
		if (error instanceof Error) {
			console.error(error.message);
		} else if (typeof error === 'string') {
			console.error(error);
		}
	}
}

const bulkActions = [
	{
		text: 'Verify DKIM',
		onClick: async () => {
			if (selectedEmailDomains.value.length > 1) {
				toast.error('You can only verify SPF for one domain at a time');
			}
			const accEmailDomainId = selectedEmailDomains.value[0].id;
			const domain: AccountEmailDomainResponse = await verifyDkim(accEmailDomainId);
			if (domain.verified) {
				fetchAccEmailDomains();
			}
		},
	},
];
const tableHeaders = [
	{ text: 'Domain', value: 'domain' },
	{ text: 'Allowed emails', value: 'list_of_allowed_emails' },
	{ text: 'Return path domain', value: 'return_path_domain' },
	{ text: 'SPF Text value', value: 'spf' },
	{ text: 'DKIM Text value', value: 'dkim' },
	{ text: 'Verified', value: 'verified' }, // Can change to dkim-verified if we want to be explicit
];
const loadingEmailDomains = ref(false);

const noEmailDomainSelected = computed(() => selectedEmailDomains.value.length === 0);
const amountOfEmailDomainsText = computed(() => `${selectedEmailDomains.value.length} email domains`);
async function addDomainClicked(domainName: string, returnPathName: string, listOfAllowedEmails: string[]) {
	const payload: AccountEmailDomainPayload = {
		domain: domainName,
		list_of_allowed_emails: listOfAllowedEmails,
	};
	if (!isNullOrUndefinedOrEmpty(returnPathName)) {
		payload.return_path_domain = returnPathName;
	}
	try {
		await addAccEmailDomain(payload);
	} catch (error) {
		toast.error('Failed to add domain');
	}
}

return { __sfc: true,fetchAccEmailDomains, addAccEmailDomain, verifyDkim, useAccountEmailDomainsArr, billingFeatureId, addVerifiedReplyToEmail, toast, openAddDomainDialog, accEmailDomains, filteredEmailDomains, selectedFilter, domainSearchInput, manageItems, manageItemsMap, selectedEmailDomains, writeClipboardText, bulkActions, tableHeaders, loadingEmailDomains, noEmailDomainSelected, amountOfEmailDomainsText, addDomainClicked, MaybeUpgradeRequiredIndicator }
}

})